define(['app', './ajax-link', 'jquery'], function (app, ajaxLink, $) {
  return ajaxLink.extend({
    counter: null,
    options: {
      callBack: function () {
        var $removebutton = this.$el
        this.counter = this.counter || $('.js-following')
        var val = parseInt(this.counter.text(), 10)
        this.counter.text(val - 1)
        var $thisRow = $removebutton.parents('.js-favorite,.js-thread')

        $thisRow.slideUp(300, function () {
          $thisRow.remove()
        })
      }
    },
    events: {
      click: 'ajaxLink'
    }
  })
})
